import { motion } from 'framer-motion'
import React, { useState } from 'react'
import styled from 'styled-components'

import { stepAnimate } from '..'
import contentstartImg from '../images/content-start.png'

interface IProps {
  testingRetest: string
  next: (stepActive: number, status?: boolean) => void
}

export default ({ testingRetest = '', next }: IProps) => {
  const handleNext = () => {
    next(0)
  }

  return (
    <Container {...stepAnimate} className="alls-testing">
      <div className="base-img" />
      <p style={{ height: 16 }}></p>
      {testingRetest ? <div className="base-tips">{testingRetest}</div> : null}
      <div className="base-title">为了保证上课质量，让我用1分钟时间帮您检测一下设备吧！</div>
      <div className="base-btn anim_btn2" onClick={handleNext}>
        开始检测
      </div>
    </Container>
  )
}

const Container = styled(motion.div)`
  .base-img {
    background-image: url('${contentstartImg}');
  }
  .base-btn {
    background: #ff5050;
    box-shadow: 0px 3px 0px 0px #d1385f;
  }
`
